import { render, staticRenderFns } from "./GenericFormUpdate.vue?vue&type=template&id=13f2de16&scoped=true&"
import script from "./GenericFormUpdate.vue?vue&type=script&lang=js&"
export * from "./GenericFormUpdate.vue?vue&type=script&lang=js&"
import style0 from "./GenericFormUpdate.vue?vue&type=style&index=0&id=13f2de16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f2de16",
  null
  
)

export default component.exports